<template>
    <v-card class="rounded-xl elevation-3 mb-4 overflow-hidden">
        <v-card-title class="text-h6 font-weight-bold pt-4 pb-3 px-6 grey lighten-5 border-b">
            <v-icon left color="teal darken-4" class="mr-2">mdi-storefront-outline</v-icon>
            Phân Quyền Quản Lý - Bán Hàng
            <v-spacer></v-spacer> 
            <v-chip color="teal lighten-4" text-color="teal darken-4" class="font-weight-bold shadow-sm" small>
                <v-icon left small>mdi-information-outline</v-icon>
                Quản lý ASM/RSM/SO/RO theo tháng
            </v-chip>
        </v-card-title>
        
        <div class="pa-4 flex-column">
            <v-alert
                text
                color="orange darken-3"
                class="mb-4 rounded-lg"
                dense
            >
                <div class="d-flex align-center">
                    <v-icon color="orange darken-3" class="mr-2">mdi-alert-circle-outline</v-icon>
                    <span class="text-subtitle-2 font-weight-medium">
                        Lưu ý: Phân quyền chỉ có hiệu lực tại tháng hiện tại
                    </span>
                </div>
            </v-alert>

            <!-- Edit Dialog -->
            <v-dialog v-model="editDialog" max-width="600px" persistent>
                <v-card class="rounded-xl overflow-hidden">
                    <v-card-title class="text-h6 font-weight-bold grey lighten-5 border-b pa-4">
                        <v-icon left color="indigo">mdi-store-edit</v-icon>
                        Cập nhật quản lý: {{ editedItem ? editedItem.storeName : '' }}
                        <v-spacer></v-spacer>
                        <v-btn icon @click="closeEdit"><v-icon>mdi-close</v-icon></v-btn>
                    </v-card-title>

                    <v-card-text class="pa-6">
                        <v-row>
                            <v-col cols="12">
                                <div class="text-subtitle-2 font-weight-bold grey--text text--darken-3 mb-2">Người Quản Lý ASM:</div>
                                <v-autocomplete
                                    v-model="editedItem.asmCode"
                                    :items="employees"
                                    item-text="name"
                                    item-value="code"
                                    :filter="customFilter"
                                    label="Chọn nhân sự ASM..."
                                    outlined
                                    dense
                                    clearable
                                    hide-details
                                    :loading="loadingEmployees"
                                    prepend-inner-icon="mdi-account-tie"
                                    class="rounded-lg"
                                >
                                    <template v-slot:item="{ item }">
                                        <v-list-item-content>
                                            <v-list-item-title>{{ item.name }} ({{ item.code }})</v-list-item-title>
                                        </v-list-item-content>
                                    </template>
                                </v-autocomplete>
                            </v-col>

                            <v-col cols="12">
                                <div class="text-subtitle-2 font-weight-bold grey--text text--darken-3 mb-2">Người Quản Lý RSM:</div>
                                <v-autocomplete
                                    v-model="editedItem.rsmCode"
                                    :items="employees"
                                    item-text="name"
                                    item-value="code"
                                    :filter="customFilter"
                                    label="Chọn nhân sự RSM..."
                                    outlined
                                    dense
                                    clearable
                                    hide-details
                                    :loading="loadingEmployees"
                                    prepend-inner-icon="mdi-account-star"
                                    class="rounded-lg"
                                >
                                    <template v-slot:item="{ item }">
                                        <v-list-item-content>
                                            <v-list-item-title>{{ item.name }} ({{ item.code }})</v-list-item-title>
                                        </v-list-item-content>
                                    </template>
                                </v-autocomplete>
                            </v-col>

                            <v-col cols="12">
                                <div class="text-subtitle-2 font-weight-bold grey--text text--darken-3 mb-2">Ghi chú:</div>
                                <v-textarea
                                    v-model="editedItem.description"
                                    label="Nội dung ghi chú..."
                                    outlined
                                    dense
                                    rows="3"
                                    hide-details
                                    class="rounded-lg"
                                    prepend-inner-icon="mdi-pencil"
                                ></v-textarea>
                            </v-col>
                        </v-row>
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions class="pa-4 bg-grey-lighten-4">
                        <v-spacer></v-spacer>
                        <v-btn text color="grey darken-1" class="px-6 rounded-lg font-weight-bold" @click="closeEdit">Hủy bỏ</v-btn>
                        <v-btn color="teal darken-4" class="white--text px-8 rounded-lg font-weight-bold shadow-sm" :loading="saving" @click="saveEdit">
                            <v-icon left>mdi-check</v-icon> Lưu Thay Đổi
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <div class="d-flex align-center mb-4">
                <v-menu
                    v-model="monthMenu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="monthDisplay"
                            label="Chọn tháng"
                            prepend-inner-icon="mdi-calendar-month"
                            readonly
                            outlined
                            dense
                            hide-details
                            v-bind="attrs"
                            v-on="on"
                            class="mr-4"
                            style="max-width: 250px;"
                        ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="selectedMonth"
                        type="month"
                        no-title
                        scrollable
                        @input="monthMenu = false"
                        color="teal darken-4"
                    ></v-date-picker>
                </v-menu>

                <v-text-field
                    v-model="search"
                    label="Tìm kiếm cửa hàng, nhân sự..."
                    prepend-inner-icon="mdi-magnify"
                    dense
                    outlined
                    hide-details
                    clearable
                    class="bg-white rounded-lg"
                ></v-text-field>
                
                <v-btn icon color="blue-grey" class="ml-2 bg-grey-lighten-3" @click="fetchData">
                    <v-icon>mdi-refresh</v-icon>
                </v-btn>
            </div>

            <v-data-table
                :headers="headers"
                :items="items"
                :search="search"
                :loading="loading"
                fixed-header
                height="600px"
                :items-per-page="-1"
                hide-default-footer
                class="elevation-0 border rounded-lg overflow-hidden custom-table"
            >
                <!-- Render Database ID Column -->
                <template v-slot:[`item.id`]="{ item }">
                    <span class="text-caption grey--text">{{ item.id }}</span>
                </template>

                <!-- Render storeAlias Column -->
                <template v-slot:[`item.storeAlias`]="{ item }">
                    <v-chip outlined small color="blue darken-4" class="font-weight-bold">{{ item.storeAlias }}</v-chip>
                </template>

                <!-- Render Store Column -->
                <template v-slot:[`item.storeName`]="{ item }">
                    <div class="d-flex flex-column py-2">
                        <span class="font-weight-bold blue-grey--text text--darken-3">{{ item.storeName }}</span>
                        <div class="d-flex align-center">
                            <v-chip x-small color="grey lighten-2" class="mr-1">{{ item.storeCode }}</v-chip>
                        </div>
                    </div>
                </template>

                <!-- Render ASM Column -->
                <template v-slot:[`item.asmName`]="{ item }">
                    <div v-if="item.asmName" class="d-flex align-center">
                        <v-avatar size="24" color="indigo lighten-4" class="mr-2">
                             <span class="indigo--text font-weight-bold" style="font-size: 10px;">ASM</span>
                        </v-avatar>
                        <div class="d-flex flex-column">
                            <span class="text-body-2 font-weight-medium">{{ item.asmName }}</span>
                            <span class="text-caption grey--text">{{ item.asmCode }}</span>
                        </div>
                    </div>
                    <span v-else class="grey--text text-caption">Chưa thiết lập</span>
                </template>

                <!-- Render RSM Column -->
                <template v-slot:[`item.rsmName`]="{ item }">
                    <div v-if="item.rsmName" class="d-flex align-center">
                        <v-avatar size="24" color="teal lighten-4" class="mr-2">
                             <span class="teal--text font-weight-bold" style="font-size: 10px;">RSM</span>
                        </v-avatar>
                        <div class="d-flex flex-column">
                            <span class="text-body-2 font-weight-medium">{{ item.rsmName }}</span>
                            <span class="text-caption grey--text">{{ item.rsmCode }}</span>
                        </div>
                    </div>
                    <span v-else class="grey--text text-caption">Chưa thiết lập</span>
                </template>

                <!-- Render Actions Column -->
                <template v-slot:[`item.actions`]="{ item }">
                    <div class="d-flex justify-center">
                        <v-btn icon small color="indigo" @click="editItem(item)" title="Chỉnh sửa">
                            <v-icon small>mdi-pencil</v-icon>
                        </v-btn>
                    </div>
                </template>

                <template v-slot:no-data>
                    <div class="pa-10 text-center">
                        <v-icon size="60" color="grey lighten-2">mdi-database-off</v-icon>
                        <div class="grey--text mt-2">Không có dữ liệu quản lý tháng này</div>
                        <v-btn color="teal darken-4" text class="mt-2" @click="fetchData">Thử lại</v-btn>
                    </div>
                </template>
            </v-data-table>
        </div>
    </v-card>
</template>

<script>
import api from '../api';
import moment from 'moment/moment';

export default {
    name: "SalesRoleCard",
    data() {
        return {
            loading: false,
            saving: false,
            search: "",
            selectedMonth: moment().format('YYYY-MM'),
            monthMenu: false,
            items: [],
            
            editDialog: false,
            editedItem: {
                id: null,
                month: null,
                storeAlias: '',
                storeName: '',
                asmCode: null,
                rsmCode: null,
                description: ''
            },
            employees: [],
            loadingEmployees: false,
            
            headers: [
                { text: 'ID', value: 'id', width: '70px', align: 'center' },
                { text: 'Alias', value: 'storeAlias', width: '80px', align: 'center' },
                { text: 'Cửa hàng', value: 'storeName', width: '30%' },
                { text: 'ASM', value: 'asmName', width: '22%' },
                { text: 'RSM', value: 'rsmName', width: '22%' },
                { text: 'Thao tác', value: 'actions', width: '100px', align: 'center', sortable: false },
            ],
        }
    },
    computed: {
        monthDisplay() {
            if (!this.selectedMonth) return '';
            return moment(this.selectedMonth).format('MM/YYYY');
        }
    },
    watch: {
        selectedMonth() {
            this.fetchData();
        }
    },
    methods: {
        customFilter(item, queryText) {
            const text = (item.name || '').toLowerCase();
            const code = (item.code || '').toLowerCase();
            const query = (queryText || '').toLowerCase();
            return text.indexOf(query) > -1 || code.indexOf(query) > -1;
        },
        editItem(item) {
            this.editedItem = JSON.parse(JSON.stringify(item));
            this.editDialog = true;
            if (this.employees.length === 0) {
                this.fetchEmployees();
            }
        },
        closeEdit() {
            this.editDialog = false;
            this.editedItem = {
                id: null,
                month: null,
                storeAlias: '',
                storeName: '',
                asmCode: null,
                rsmCode: null,
                description: ''
            };
        },
        saveEdit() {
            this.saving = true;
            
            // Payload theo yêu cầu của backend (PascalCase)
            const payload = {
                month: this.editedItem.month,
                asmCode: this.editedItem.asmCode,
                rsmCode: this.editedItem.rsmCode,
                storeAlias: this.editedItem.storeAlias
            };

            api.updateSalesManager(payload).then(() => {
                this.closeEdit();
                this.fetchData();
            }).catch(err => {
                console.error("Update sales manager error:", err);
                alert("Có lỗi xảy ra khi cập nhật!");
            }).finally(() => {
                this.saving = false;
            });
        },
        fetchEmployees() {
            this.loadingEmployees = true;
            api.getEmployees({ dropDown: 1 }).then(data => {
                this.employees = data;
            }).catch(err => {
                console.error("fetch employees error", err);
            }).finally(() => {
                this.loadingEmployees = false;
            });
        },
        fetchData() {
            this.loading = true;
            const queryMonth = moment(this.selectedMonth).format('YYYY-MM-01');
            api.getSalesManagers(queryMonth).then(data => {
                this.items = data || [];
            }).catch(err => {
                console.error("fetch sales managers error", err);
            }).finally(() => {
                this.loading = false;
            });
        }
    },
    created() {
        this.fetchData();
    }
}
</script>

<style scoped>
.shadow-sm { box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05); }
.border-b { border-bottom: 1px solid #edf2f7; }
.bg-grey-lighten-4 { background-color: #f8fafc; }
.bg-grey-lighten-3 { background-color: #f1f5f9; }

.custom-table ::v-deep th {
    background-color: #f8fafc !important;
    text-transform: uppercase;
    font-size: 0.75rem !important;
    font-weight: bold !important;
    color: #64748b !important;
    letter-spacing: 0.05em;
    height: 48px !important;
}

.custom-table ::v-deep td {
    height: 64px !important;
}
</style>
